// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__2DKhT","actions":"NotFound_actions__3QOl0"};